import { Link } from "react-router-dom";
import { LEGAL_PAGES } from "@gaole/shared";

export function PolicyConsentCheckbox({
  variant,
  checked,
  onChange,
}: {
  variant: "register" | "checkout";
  checked: boolean;
  onChange: (checked: boolean) => void;
}) {
  const linkClass = "font-semibold text-brand-pink underline-offset-2 hover:underline";

  return (
    <label className="flex cursor-pointer items-start gap-2.5 rounded-xl border border-white/10 bg-white/[0.03] p-3 text-left">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 shrink-0 rounded border-white/20 bg-white/5 accent-brand-pink"
        required
      />
      <span className="text-[11px] leading-relaxed text-white/70">
        {variant === "register" ? (
          <>
            I agree to the{" "}
            <Link to="/legal/terms" target="_blank" rel="noopener noreferrer" className={linkClass}>
              Terms & Conditions
            </Link>{" "}
            and{" "}
            <Link to="/legal/privacy" target="_blank" rel="noopener noreferrer" className={linkClass}>
              Privacy Policy
            </Link>
            .
          </>
        ) : (
          <>
            I agree to the{" "}
            <Link to="/legal/terms" target="_blank" rel="noopener noreferrer" className={linkClass}>
              Terms & Conditions
            </Link>
            ,{" "}
            <Link to="/legal/privacy" target="_blank" rel="noopener noreferrer" className={linkClass}>
              Privacy Policy
            </Link>
            ,{" "}
            <Link to="/legal/refund" target="_blank" rel="noopener noreferrer" className={linkClass}>
              Refund Policy
            </Link>
            , and{" "}
            <Link to="/legal/shipping" target="_blank" rel="noopener noreferrer" className={linkClass}>
              Shipping Policy
            </Link>
            .
          </>
        )}
      </span>
    </label>
  );
}
